import {
    Box,
    Text,
    VStack,
    HStack,
    Icon,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Grid,
} from '@chakra-ui/react';
import { TbFlag } from 'react-icons/tb';
import { OrderDrawerResponse } from '../../hooks/useGetOrderDrawer';
import StatBox from '../StatBox';

interface RekeyTabPanelProps {
    data: NonNullable<OrderDrawerResponse['rekey']>;
}

const RekeyTabPanel = ({ data }: RekeyTabPanelProps) => {
    return (
        <VStack align="stretch" spacing={4}>
            <Text fontSize="xs" fontWeight="bold" color="gray.500" letterSpacing="wide" textTransform="uppercase">
                RE-KEY OVERVIEW
            </Text>
            {/* Summary Boxes */}
            <Grid templateColumns="repeat(4, 1fr)" gap={2}>
                <StatBox label="PARTS CONFIRMED" value={data.totalConfirmed} />
                <StatBox label="PARTS RE-KEYED" value={data.totalRekeyed} />
                <StatBox label="PARTS FLAGGED" value={data.partsFlagged} />
                <StatBox label="ADVISOR PARTS" value={data.partsAdvisor} />
            </Grid>

            {/* Summary Table */}
            {data.flaggedParts && data.flaggedParts.length > 0 ? (
                <Box
                    borderWidth="1px"
                    borderColor="orange.200"
                    borderRadius="lg"
                    overflow="hidden"
                    bg="white"
                    boxShadow="none"
                >
                    <Box bg="orange.50" px={4} py={3} borderBottomWidth="1px" borderColor="orange.200">
                        <HStack>
                            <Icon as={TbFlag as React.ElementType} color="orange.500" />
                            <Text fontSize="sm" fontWeight="bold" color="orange.700">
                                Flagged Parts ({data.partsFlagged})
                            </Text>
                        </HStack>
                    </Box>
                    <Box borderTop="1px solid" borderColor="gray.200">
                        <Table variant="simple" size="sm" w="100%">
                            <Thead bg="gray.50">
                                <Tr>
                                    <Th pl={6} color="gray.500" borderColor="gray.200">LINE NUMBER</Th>
                                    <Th color="gray.500" borderColor="gray.200">PART NAME</Th>
                                    <Th pr={6} color="gray.500" borderColor="gray.200">FLAG REASON</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {data.flaggedParts.map((part) => (
                                    <Tr key={part._id}>
                                        <Td py={3} pl={6} borderColor="gray.200">
                                            <Text fontSize="sm" color="gray.700">
                                                {part.lineNumber}
                                            </Text>
                                        </Td>
                                        <Td py={3} borderColor="gray.200">
                                            <Text fontWeight="medium" color="gray.900">{part.title}</Text>
                                        </Td>
                                        <Td py={3} pr={6} borderColor="gray.200">
                                            <Text fontSize="sm" color="gray.700">
                                                {part.flagReason || 'Flagged during re-key'}
                                            </Text>
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </Box>
                </Box>
            ) : (
                <Box
                    borderWidth="1px"
                    borderColor="gray.200"
                    borderRadius="lg"
                    p={6}
                    textAlign="center"
                    bg="gray.50"
                >
                    <Text color="gray.500">No flagged parts in re-key.</Text>
                </Box>
            )}
        </VStack>
    );
};

export default RekeyTabPanel;

